var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-xunbu"},[_c('my-markdown',{staticClass:"product-xunbu_md",attrs:{"content":_vm.config.aboutAPP}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }